import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { SessionTimer } from "./SessionTimer";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  deleteCookie,
  getCookie,
  getUserRole,
  parseJwt,
  setCookie,
} from "../common";
import WithConditional from "./WithConditional";
import Loader from "./Loader";
import { useAccessTokenByRefresh } from "../common";

export const SessionDialogue = ({
  authTokenRefreshesIn,
  idleTime,
  authTokenExpiresIn,
}) => {
  const [showDialogueTimer, setShowDialogueTimer] = useState(false);
  const [expiryDate, setExpiryDate] = useState(0);
  const showDialogueTimerRef = useRef(showDialogueTimer);
  // const { timerRef } = useContext(UserContext);
  const navigate = useNavigate();
  const accessTokenByRefreshMutation = useAccessTokenByRefresh();
  const enqueueSnackbar = useSnackbar();
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
 
  const activityDebounceRef = useRef(null);
    const  timerRef  = useRef(null);


  const timeout = idleTime * 60 * 1000; // 1 minute
 
  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      const authAccesstoken = getCookie("authAccessTokenInfo");
      if (authAccesstoken !== undefined && authAccesstoken !== null) {
        const accessTokenJwt = parseJwt(authAccesstoken);
        setShowDialogueTimer(true);
        setExpiryDate(accessTokenJwt.exp * 1000);
        //setExpiryDate(Date.now() + 5*60*1000)
      }
    }, timeout);
  };
 
  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
 
    resetTimer(); // start timer on mount
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, []);
 
  const refreshSession = () => {
    const refresh_token = getCookie("refreshToken");
    accessTokenByRefreshMutation.mutate(
      {
        body: {
          grant_type: "refresh_token",
          refresh_token: refresh_token,
          client_id: process.env.REACT_APP_PING_CLIENT_ID,
        },
        config: config,
      },
      {
        onSuccess: (data, variables) => {
          setCookie("authAccessTokenInfo", data?.access_token); //setting cookie
        },
        onError: (error, variables) => {
          console.log("error in mutation is", error.error, typeof error);
          console.log("variables are", variables);
          console.log("error is",error.response)
          if (error?.error === "invalid_grant") {
            signout();
          }
          enqueueSnackbar(error.message, {
            variant: "error",
          });
        },
 
        onSettled: (data, error) => {
          handleCloseDialogueTimer();
        },
      }
    );
 
    // getAccessTokenFromRefreshToken(refresh_token)
    //   .then((response) => {
    //     setCookie("authAccessTokenInfo", response?.data?.access_token); //setting cookie
    //     handleCloseDialogueTimer();
    //   })
    //   .catch((err) => {
    //     if (err.response.error === "invalid_grant") {
    //       handleSignOut();
    //       handleCloseDialogueTimer();
    //     }
    //   });
  };
 
  const signout = () => {
    deleteCookie("idToken");
    deleteCookie("refreshToken");
    deleteCookie("authAccessTokenInfo");
    deleteCookie("userInfo");
    clearTimeout(timerRef.current)
    navigate("/signout");
  };
 
  const handleCloseDialogueTimer = (event, reason) => {
    if (reason == "backdropClick") {
      return;
    }
    setShowDialogueTimer(false);
  };
 
  console.log(accessTokenByRefreshMutation.isPending);
 
  useEffect(() => {
    const handleActivity = (event) => {
      // Clear previous debounce timer
      if (activityDebounceRef.current) {
        clearTimeout(activityDebounceRef.current);
      }
 
      // Set new debounce timer - only execute after 500ms of inactivity
      activityDebounceRef.current = setTimeout(() => {
        const authAccesstoken = getCookie("authAccessTokenInfo");
        if (authAccesstoken !== undefined && authAccesstoken !== null) {
          const accessTokenJwt = parseJwt(authAccesstoken);
 
          // 20 minutes in milliseconds
          const expiryDate = new Date(accessTokenJwt.exp * 1000);
          const now = new Date();
          const diff = expiryDate - now;
          const timeToRefreshTokenMilliseconds =
            (authTokenExpiresIn - authTokenRefreshesIn) * 60 * 1000;
          const remainingTimeInExpiryAfterIdle =
            (authTokenExpiresIn - idleTime) * 60 * 1000;
          console.log("difference is", diff);
          if (
            diff > 0 &&
            diff < timeToRefreshTokenMilliseconds &&
            showDialogueTimerRef.current === false &&
            accessTokenByRefreshMutation?.isPending === false
          ) {
            refreshSession();
          } else if (diff <= 0) {
            signout();
          }
        }else{
          console.log("hello I am here k")
           signout();
        }
      }, 500); // Wait 500ms after last activity before checking
    };
 
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
 
    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      if (activityDebounceRef.current) {
        clearTimeout(activityDebounceRef.current);
      }
    };
  }, []);
 
  useEffect(() => {
    showDialogueTimerRef.current = showDialogueTimer;
  }, [showDialogueTimer]);
 
  return (
    <Fragment>
      <WithConditional when={accessTokenByRefreshMutation.isPending}>
        <Loader />
      </WithConditional>
      <WithConditional when={showDialogueTimer}>
        <SessionTimer
          expiry={expiryDate}
          signout={signout}
          refreshSession={refreshSession}
          showDialogueTimer={showDialogueTimer}
          handleCloseDialogueTimer={handleCloseDialogueTimer}
        />
      </WithConditional>
    </Fragment>
  );
};